import React, {useContext, useState} from "react";
import {directusContext} from "../../app/DirectusProvider";
import {useNavigate, useSearchParams} from "react-router-dom";
import AuthForm from "../common/AuthForm";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const ResetPassword = () => {
    const {directus, updateVersion} = useContext(directusContext);
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const input = token ? {
        id: "password",
        type: "password",
        label: t("auth.newPassword"),
        placeholder: "********",
        required: true,
        value: password,
        onChange: (e) => setPassword(e.target.value)
    } : {
        id: "email",
        type: "email",
        label: t("auth.email"),
        placeholder: "mail@gmail.com",
        required: true,
        value: email,
        onChange: (e) => setEmail(e.target.value)
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (token) { //Changement de mot de passe
            if (password.length < 8) {
                toast.error("Le mot de passe doit faire au minimum 8 caractères!");
            } else {
                directus.auth.password.reset(token, password).then(() => {
                    toast.success("Mot de passe changé avec succès !");
                    updateVersion();
                    navigate("/login");
                });
            }
        } else {     //Demande de changement de mot de passe
            directus.auth.password.request(email, "https://rm.pgpc.ch/reinitialiser-acces").then(() => {
                toast.success("Un email contenant les instructions de réinitialisation de mot de passe vous a été envoyé.");
            }).catch(() => {
                toast.error("Veuillez vérifier l'adresse fournie");
            });
        }
    };

    return (
        <AuthForm input1={input} input2={false} buttonText={t("auth.valider")} error={false} handleSubmit={onSubmit}
                  title={t("auth.passChange")}/>
    )
};

export default ResetPassword;
